export default {
    getLogsInogreen: (fromDate, toDate) => {
        return {
            url: '/logs/env/:env',
            method: 'GET',
            route_params: {
                env: 'inogreen',
            },
            get_params: {
                fromDate,
                toDate,
            },
        };
    },
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsInogreen/api.js